import { Component, OnInit, } from '@angular/core';
import {ActivatedRoute, Router, Params } from '@angular/router';
import {AdoptionService} from '../../services/adoption.service';
import {Adoption} from '../../classes/adoption.interface';
import {Breed} from '../../classes/breed.interface';
import {Location} from '../../classes/location.interface';
@Component({
  selector: 'app-adoptionlist',
  templateUrl: './adoptionlist.component.html',
  styleUrls: ['./adoptionlist.component.css'],
  
})
export class AdoptionlistComponent implements OnInit {
  loc: any;
  contactno = [];
  animaltype: any;
  breed: Breed[];
  location = [];
  adoption: Adoption[];
  breedfilterarray = [];
  colorfilterarray = [];
  agefilterarray = [];
  locationfilterarray = [];
  cityfilterarray = [];
  user_id = 35;
  selectedcity: any;
  age = ['0-1', '1-2', '2-3' , '3-4', '4-5', 'above 5'];
  color = ['Black','White','Brown','Gray','Fawn','Mix'];
  city= [];
  public loading = false;
  constructor(private route: ActivatedRoute, private router: Router,
  private adoptionService: AdoptionService) {
    window.scrollTo(0, 0);
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.animaltype = id;
       });
   }


  ngOnInit() {
    this.loading = true;
    this.adoptionService.getParticulerBreed(this.animaltype)
    .subscribe(
      (x: Breed[]) => {
        this.loading = false;
          this.breed = x;
      }
    );
    this.adoptionService.getAdoptionpost(this.animaltype)
    .subscribe(
      (x: Adoption[]) => {
        this.loading = false;
        this.adoption = x;
      }
    );
    this.getAdoptionCity()
  }

  getAdoptionLocation(lid) {
    this.loading = true;
    this.adoptionService.getLocation(lid)
    .subscribe(
      (x) => {
        this.loading = false;
        this.loc = x;
        this.createlocation();
      }
    );
  }
  createlocation() {
    for (let i = 0 ; i < this.loc.length ; i++) {
      this.location.push(this.loc[i]);
    }
  }
  getAdoptionCity() {
    this.adoptionService.getAdoptionCity()
    .subscribe(
      (x: Location[]) => {
        this.loading = false;
        this.city = x;
      }
    );
  }
  filterBreed(e, data) {
    if (e.target.checked) {
      this.breedfilterarray.push(data);
    }
    if (!e.target.checked) {
      for ( let i = 0 ; i < this.breedfilterarray.length; i++) {
        if (this.breedfilterarray[i] === data) {
          this.breedfilterarray.splice(i, 1);
        }
      }
    }
  }
  filterColor(e, data) {
    if (e.target.checked) {
      this.colorfilterarray.push(data);

    }
    if (!e.target.checked) {
      for ( let i = 0 ; i < this.colorfilterarray.length; i++) {
        if (this.colorfilterarray[i] === data) {
          this.colorfilterarray.splice(i, 1);
        }
      }
    }
  }
  filterAge(e, data) {
    if (e.target.checked) {
      this.agefilterarray.push(data);
    }
    if (!e.target.checked) {
      for ( let i = 0 ; i < this.agefilterarray.length; i++) {
        if (this.agefilterarray[i] === data) {
          this.agefilterarray.splice(i, 1);
        }
      }
    }
  }
  filterLocation(e, data) {
    if (e.target.checked) {
      this.getAdoptionLocation(data);
      this.locationfilterarray.push(data);
    }
    if (!e.target.checked) {
      for ( let i = 0 ; i < this.locationfilterarray.length; i++) {
        if (this.locationfilterarray[i] === data) {
          this.locationfilterarray.splice(i, 1);
        }
      }
    }
  }
  filterCity(e, data) {
    if (e.target.checked) {
      this.getAdoptionLocation(data);
      this.cityfilterarray.push(data);

    }
    if (!e.target.checked) {
      this.removelocationfromArray(data);
      for ( let i = 0 ; i < this.cityfilterarray.length; i++) {
        if (this.cityfilterarray[i] === data) {
          this.cityfilterarray.splice(i, 1);
        }
      }
     }
  }
  removelocationfromArray(data) {
    let i = this.location.length;
    while (i --) {
      if (this.location[i].parent_location_id === data) {
         this.removelocationFilterdata(this.location[i].id)
        this.location.splice(i, 1);
        }
    }
  }
  removelocationFilterdata(lid) {
    for ( let i = 0 ; i < this.locationfilterarray.length ; i++) {
      if (this.locationfilterarray[i] === lid) {
        this.locationfilterarray.splice(i , 1);
      }
    }
  }
  getContact( uid, pid) {
        this.adoptionService.getPostContact(uid)
        .subscribe(
          (x) => {
            this.contactno['id' + pid] = x.mobile;
          }
        );
  }
}
